const NavMain = () => {
  const $$linksWithChildren = document.querySelectorAll(
    '.NavMain__link--has-children'
  )

  const self = {
    init () {
      self.addEventListeners()
    },
    addEventListeners () {
      const $menu = document.querySelector('.NavMain__items')
      const $trigger = document.querySelector('.NavMain__trigger')
      const $toggle = document.querySelectorAll('.NavMain__toggle_sub')

      if ($$linksWithChildren.length > 0) {
        ;[...$$linksWithChildren].forEach($linkWithChild => {
          $linkWithChild.addEventListener('mouseover', self.onClickLinkWithChildren)
        })
      }

      $menu.addEventListener('mouseleave', self.onClickLinkWithChildrenOut)

      if ($trigger) {
        $trigger.addEventListener('click', self.onClickTrigger)
      }

      if ($toggle) {

        for (let i = 0; i < $toggle.length; i++) {
          $toggle[i].addEventListener('click', self.onMenuClickTrigger)
        }

        
      }

  
    },
    onClickTrigger (e) {
      document.body.classList.toggle('nav-is-open')
    },
    onMenuClickTrigger (e) {
      console.log('!!')
      e.target.closest('.NavMain__item ').classList.toggle('has-open-children')
    },
    onClickLinkWithChildren (e) {
      if (window.innerWidth > 1024) {
        e.target.closest('.NavMain__item ').classList.add('has-open-children')
      }
    },
    onClickLinkWithChildrenOut(e) {
      if (window.innerWidth > 1024) {
        ;[...$$linksWithChildren].forEach($linkWithChild => {
          $linkWithChild.closest('.NavMain__item ').classList.remove('has-open-children')
        })
      }

    }
  }

  return self
}

export default NavMain
